import React from 'react';
import { Card, CardProps } from '@mui/material';

const PageCard: React.FC<CardProps> = ({ children, ...props }) => (
  <Card
    sx={{
      minWidth: 1200,
      maxWidth: 1400,
      width: '100%',
      borderRadius: 2,
      boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
      border: '1px solid #e2e8f0',
      overflow: 'hidden',
      ...props.sx
    }}
    {...props}
  >
    {children}
  </Card>
);

export default PageCard;
